import React from 'react';
import { Link } from 'react-router-dom';

interface LoginData {
  username: string;
  password: string;
}

interface SuperAdminLoginProps {
  loginData: LoginData;
  setLoginData: (data: LoginData) => void;
  isLoading: boolean;
  onSubmit: (e: React.FormEvent) => void;
}

const SuperAdminLogin: React.FC<SuperAdminLoginProps> = ({
  loginData,
  setLoginData,
  isLoading,
  onSubmit
}) => {
  return (
    <div className="bg-white rounded-3xl p-8 md:p-12 border border-ice-teal-light shadow-xl max-w-md w-full mx-4">
      <div className="text-center mb-8">
        <div className="flex items-center justify-center mb-4">
          <img
            src="/icepop.png"
            alt="Waddle & Sip"
            className="h-16 w-16 mx-auto"
          />
        </div>
        <h1 className="text-3xl font-title font-bold text-deep-navy mb-2">SUPER ADMIN LOGIN</h1>
        <p className="text-gray-600 font-body">Access the system administration panel</p>
      </div>

      <form onSubmit={onSubmit} className="space-y-6">
        <div>
          <label htmlFor="username" className="block text-deep-navy font-bold mb-2">
            Username
          </label>
          <input
            type="text"
            id="username"
            value={loginData.username}
            onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
            required
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-gray-800 placeholder-gray-500 focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors"
            placeholder="Enter username"
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-deep-navy font-bold mb-2">
            Password
          </label>
          <input
            type="password"
            id="password"
            value={loginData.password}
            onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
            required
            className="w-full px-4 py-3 bg-white border border-gray-300 rounded-xl text-gray-800 placeholder-gray-500 focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue transition-colors"
            placeholder="Enter password"
          />
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="w-full btn-primary disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isLoading ? 'Logging in...' : 'LOGIN'}
        </button>
      </form>

      <div className="text-center mt-6">
        <Link to="/" className="text-gray-500 hover:text-brand-blue transition-colors font-body">
          ← Back to Home
        </Link>
      </div>
    </div>
  );
};

export default SuperAdminLogin;
